<nz-card nzTitle="Construction Details">
  <nz-skeleton
    [nzActive]="true"
    [nzLoading]="(loading$ | async) ?? false"
    [nzParagraph]="{ rows: 4 }"
  >
    <ng-container *ngIf="errorMessage$ | async as errorMsg; else result">
      <em-error-result [subTitle]="errorMsg"></em-error-result>
    </ng-container>
  </nz-skeleton>
</nz-card>

<ng-template #result>
  <nz-descriptions
    *ngIf="construction$ | async as construction; else noData"
    nzLayout="vertical"
    nzTitle="Construction Id: {{ construction.constructionId }}"
  >
    <nz-descriptions-item nzTitle="Mould Type">
      <em-display-property [value]="construction.mouldTypeDescription"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Machine Type">
      <em-display-property [value]="construction.machineTypeDescription"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Ejector Type">
      <em-display-property [value]="construction.ejectorTypeDescription"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Box Concept">
      <em-display-property [value]="construction.boxConceptDescription"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Box Layout" [nzSpan]="2">
      <em-display-property [value]="construction.boxLayoutDescription"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Gate Opening">
      <em-display-property [value]="construction.gateOpening"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Ejector Tap" [nzSpan]="2">
      <em-display-property [value]="construction.ejectorTap"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Number of Inserts">
      <em-display-property [value]="construction.numberOfInserts"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Number of Elements">
      <em-display-property [value]="construction.numberOfElements"></em-display-property>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Inductive Sensor">
      <em-display-property [value]="construction.inductiveSensor"></em-display-property>
    </nz-descriptions-item>
  </nz-descriptions>
</ng-template>

<ng-template #noData>
  <nz-empty></nz-empty>
</ng-template>
